import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(69, 152, 166, 1)',
      light: 'rgba(123, 186, 197, 1)',
      dark: 'rgba(46, 106, 116, 1)',
    },
    secondary: {
      main: 'rgba(202, 227, 232, 1)',
      light: 'rgba(245, 246, 250, 1)',
      dark: 'rgba(158, 186, 191, 1)',
    },
    background: {
      default: '#ffffff',
      paper: 'rgba(202, 227, 232, 1)',
    },
    text: {
      primary: 'rgba(32, 34, 36, 1)',
      secondary: 'rgba(0, 0, 0, 0.85)',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      'Montserrat',
      'Nunito Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});